import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const options = {
  fallbackLng: 'es',
  load: 'languageOnly',
  ns: ['translations', 'layout', 'banners'],
  defaultNS: 'translations',
  saveMissing: false,
  debug: false,
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
    format: (value, format, lng) => {
      if (format === 'uppercase') return value.toUpperCase();
      return value;
    },
  },
  wait: process && !process.release,
};

if (process && !process.release) {
  i18n.use(Backend).use(initReactI18next);
}

if (!i18n.isInitialized) {
  i18n.init(options);
}

export default i18n;
